export { environment } from './src/environments/environment';
export { C4Environment, baseEnvironment } from './src/environments/base';

// Formerly /core services
export * from './src/app/services/common-config.service';
export * from './src/app/services/console.service';
export * from './src/app/services/controller-connection.service';
export * from './src/app/services/core-config.service';
export * from './src/app/services/exception-handler.service';
export * from './src/app/services/http.service';
export * from './src/app/services/log.service';
export * from './src/app/services/monitored-http.service';
export * from './src/app/services/resource.service';
export * from './src/app/services/status.service';
export * from './src/app/services/view-broker.service';
export * from './src/app/services/window.service';

// Formerly /api services
export * from './src/app/services/account.service';
export * from './src/app/services/broker.service';
export * from './src/app/services/category.service';
export * from './src/app/services/configuration.service';
export * from './src/app/services/device.service';
export * from './src/app/services/guid.service';
export * from './src/app/services/item.service';
export * from './src/app/services/location.service';
export * from './src/app/services/platform.service';
export * from './src/app/services/registration.service';
export * from './src/app/services/service-locator.service';
export * from './src/app/services/storage.service';
export * from './src/app/services/update.service';
export * from './src/app/services/url-factory.service';
export * from './src/app/services/backup.service';

// Also export them under their old
// names for backwards compatibility
export { AccountService as Accounts } from './src/app/services/account.service';
export { BrokerService as Broker } from './src/app/services/broker.service';
export { CategoryService as Categories } from './src/app/services/category.service';
export { ConfigurationService as Configuration } from './src/app/services/configuration.service';
export { DeviceService as Devices } from './src/app/services/device.service';
export { GUIDService as GUID } from './src/app/services/guid.service';
export { ItemService as Items } from './src/app/services/item.service';
export { LocationService as Locations } from './src/app/services/location.service';
export { PlatformService as Platform } from './src/app/services/platform.service';
export { RegistrationService as Registration } from './src/app/services/registration.service';
export { ServiceLocatorService as ServiceLocator } from './src/app/services/service-locator.service';
export { StorageService as Storage } from './src/app/services/storage.service';
export { UpdateService as Update } from './src/app/services/update.service';
export { UrlFactoryService as URLFactory } from './src/app/services/url-factory.service';

export * from './src/app/director-connection/director-connected.guard';
export * from './src/app/director-connection/director-ready.guard';
export * from './src/app/director-connection/director-connection.service';
export * from './src/app/services/router-history.service';

export * from './src/app/interfaces/reducer';
export * from './src/app/interfaces/store';

export * from './src/app/app.module';
export { CORE_STORE } from './src/app/core.store';



// WEBPACK FOOTER //
// ./~/@c4/core/index.ts